import React, { Component } from 'react';
import {  Box, Button, Drawer, Stack, TextField, Tooltip, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { withTranslation } from 'react-i18next';
import '../../../FrontOffice/FOReports/reports.css';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import CommonDatePicker from '../../../../Components/Common Components/CommonDatePicker';
import { CommonGridToolBarWithFilterText, CommonPatientDetails } from "../../../../Components/Common Components/CommonComponents";
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { DateTime } from 'luxon';
import { splitDate, AmountFormat, formatDate } from '../../../../Components/CommonFunctions/CommonFunctions';
import { localGetItem } from '../../../../Utility/Services/CacheProviderService';
import { AmountsCard } from '../../../../Components/CommonCards/CommonCards';
import Loader from '../../../../Components/Loader';
import { CurrencySymbol } from '../../../../Utility/Constants';

class DoorDeliveryReport extends Component {

    constructor(props) {
        super(props)
        this.state = {
            page: 0,
            pageSize: 10,
            fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            dateIndex: 1,
            deliveryList: [],
            billNumber: "",
            total_bill_amount: 0,
            total_concession: 0,
            patient_name : "",
            uhid : "",
            printLoading: false,
            disableBtn: false,
        }
    }

    componentDidMount() {      
        this.getDoorDeliverylist()
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
        })
    }

    FilterDate = (from, to, index) => {
        this.setState({
            fromDate: from,
            toDate: to,
            dateIndex: index
        })
    }

    LoaderFunction = (key) => {
        this.setState({
            isLoader: key
        })
    }
    handleCheckBox = (e, data) => {
        let states = this.state
        data["isChecked"] = e.target.checked
        this.setState({ states })
    }

    getDoorDeliverylist = () => {
        try {            
            let LoggedUserData = JSON.parse(localGetItem("loggedInUserInfo"))
            this.LoaderFunction(true);
            const baseUrl = Serviceurls.DOOR_DELIVERY_REPORT;
            RestAPIService.getAll(`${baseUrl}?from_date=${this.state.fromDate}&to_date=${this.state.toDate}&bill_no=${this.state.billNumber}&patient_name=${this.state.patient_name}&uhid=${this.state.uhid ? this.state.uhid :""}&pharmacy_id=${LoggedUserData.pharmacy_id ? LoggedUserData.pharmacy_id :""}&clinic_id=${LoggedUserData.clinic_id ? LoggedUserData.clinic_id :""}`)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.LoaderFunction(false);
                        let list = response.data?.data || [];
                        list = list.map((item, index) => ({
                            ...item,
                            sno: index + 1,
                        }));
                        this.setState({ deliveryList: list });
                    }
                }).catch((error) => {
                    if (error?.response?.data?.status === 'fail') {
                        this.LoaderFunction(false);
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.LoaderFunction(false);
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    printReports = () => {
        try {
            let LoggedUserData = JSON.parse(localGetItem("loggedInUserInfo"))
            
            const baseUrl = Serviceurls.DOOR_DELIVERY_REPORT;
            RestAPIService.getAll(`${baseUrl}?from_date=${this.state.fromDate}&to_date=${this.state.toDate}&bill_no=${this.state.billNumber}&patient_name=${this.state.patient_name}&uhid=${this.state.uhid ? this.state.uhid :""}&pharmacy_id=${LoggedUserData.pharmacy_id ? LoggedUserData.pharmacy_id :""}&clinic_id=${LoggedUserData.clinic_id ? LoggedUserData.clinic_id :""}&export_type=pdf`)
                .then((response) => {
                    if (response) {
                        //Create a Blob from the PDF Stream
                        const file = new Blob(
                            [response.data],
                            { type: 'application/pdf' });
                        //Build a URL from the file
                        const fileURL = URL.createObjectURL(file);
                        //Open the URL on new Window
                        window.open(fileURL);
                        this.setState({disableBtn: false, printLoading: false})
                    }
                }).catch((error) => {
                    if (error?.response?.data?.status === 'fail') {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                    this.setState({disableBtn: false, printLoading: false})
                })
        } catch (error) {
            this.errorMessage(error.message)
            this.setState({disableBtn: false, printLoading: false})
        }
    }
   
    renderFilterScreen = () => {
        const { t } = this.props
        return (
            <Box component={"div"} className='eMed_rts_filter_container'>
                <Box component={"div"} className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{t("Filter")}</Typography>
                    <Button emed_tid={'filter_btn'} onClick={() => { this.setState({ FilterOpen: false }) }} className='eMed_usrconf_btn'>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>
                <Box className='eMed_rts_middle' overflow={'auto'}>
                    <Box className='eMed_date_filter'>
                        <CommonDatePicker
                            FromDate={this.state.fromDate}
                            ToDate={this.state.toDate}
                            emed_tid = {"FilterDate_TestID01"} 
                            DateIndex={this.state.dateIndex}
                            SelectedDates={this.FilterDate.bind(this)}
                            HideAllMenu={true} />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <TextField
                            sx={{width: "20vw"}}
                            inputProps={{ maxLength: 6 , emed_tid: 'billnumber'}}
                            size='small'
                            label={t("BillNumber")}
                            value={this.state.billNumber}
                            autoComplete='off'
                            emed_tid = {"BillNumberTestID01"} 
                            onChange={(e) => {
                                let number = CommonValidation.numberOnly(e.target.value);
                                if (number || e.target.value === "") {
                                    this.setState({ billNumber: e.target.value })
                                }
                            }}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <TextField
                            sx={{width: "20vw"}}
                            inputProps={{ maxLength: 20 , emed_tid: 'patient_name'}}
                            size='small'
                            label={t("Patient Name")}
                            value={this.state.patient_name}
                            autoComplete='off'
                            emed_tid = {"patient_nameTestID01"} 
                            onChange={(e) => {
                                let alpha = CommonValidation.alphabetOnly(e.target.value);
                                if (alpha || e.target.value === "") {
                                    this.setState({ patient_name: e.target.value })
                                }
                            }}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <TextField
                            sx={{width: "20vw"}}
                            inputProps={{ maxLength: 20 , emed_tid: 'UHID'}}
                            size='small'
                            label={t("UHID")}
                            value={this.state.uhid ? this.state.uhid :""}
                            autoComplete='off'
                            emed_tid = {"UHIDTestID01"} 
                            onChange={(e) => {
                                let number = CommonValidation.ALPHA_NUM_SPLCHAR(e.target.value);
                                if (number || e.target.value === "") {
                                    this.setState({ uhid: e.target.value })
                                }
                            }}
                        />
                    </Box>
                </Box>
                <Stack spacing={2} direction="row" alignItems="center" justifyContent="center">
                    <Button variant='outlined' size="small"  emed_tid = {"doordeliveryTestID01"} 
                        onClick={() => {
                            if (localGetItem("multiLaboratory") === "true") {
                                this.state.LabData?.forEach((item) => (item["isChecked"] = true))
                            }
                            this.setState({
                                billNumber: "",
                                patient_name :"",
                                uhid :"",
                                fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                dateIndex: 1,
                            }, () => this.getDoorDeliverylist())
                        }}
                        id="eMed_Config_btn">{t("Clear")}</Button>
                    <Button variant='contained' size="small" emed_tid = {"Search_TestID01"} 
                        onClick={() => {
                            this.getDoorDeliverylist()
                            this.setState({
                                FilterOpen: false
                            })
                        }}
                        id="eMed_Config_btn"  >{t("Search")}</Button>
                </Stack>
            </Box>
        )
    }

    gridToolBar = () => {
        let TextArray = [
            { label: "From Date", value: formatDate(this.state.fromDate) },
            { label: "To Date", value: formatDate(this.state.toDate) },
        ]
        return (
            <Box>
                <CommonGridToolBarWithFilterText FilterTextArray={TextArray} />
            </Box>

        )
    }
    
    render() {
        const { t } = this.props
        const columns = [
            {
                field: "patient_name", headerName: t("Patient Details"), flex: 0.16, density: 'compact',
                renderCell: ({ row }) => (<CommonPatientDetails data={row} disablePhoto={true} />), valueGetter: (params) => {
                    const name = params.row?.patient_name || "";
                    const mobile = params.row?.patient_mobile_number || "";
                    const UHID = params.row?.uhid || "";
                    return `${name} ${mobile} ${UHID}`;
                }
            },
            {
                field: "bill_no", headerName: t("Bill No"), flex: 0.15, align: "center", headerAlign: "center", density: 'compact',
                renderCell: ({ row }) => (<Box component={'div'}>{row?.bill_no?.length > 25 ?
                        <Tooltip placement='top' title={row?.bill_no} arrow><div>{row?.bill_no.slice(0, 23) + "..."}</div></Tooltip>
                        : row?.bill_no ? row?.bill_no : "-"}</Box>)
            },
            {
                field: "date", headerName: t("Bill Date"), flex: 0.10, align: "center", headerAlign: "center", density: 'compact',
                renderCell: ({ row }) => (<Box component={'div'}>{row?.date ? splitDate(row?.date) : "-"}</Box>)
            },
            {
                field: "bill_amount", headerName: t("Bill Amount"), flex: 0.10, type: "number", density: 'compact',
                renderCell: ({ row }) => (<Box component={'div'}>{row?.bill_amount ? AmountFormat(row?.bill_amount).replace(`${CurrencySymbol}`, "") : "0.00"}</Box>)
            },
            // {
            //     field: "paid_amount", headerName: t("Paid Amount"), flex: 0.10, type: "number", density: 'compact',
            //     renderCell: ({ row }) => (<Box component={'div'}>{row?.paid_amount ? AmountFormat(row?.paid_amount).replace(`${CurrencySymbol}`, "") : "0.00"}</Box>)
            // },
            // {
            //     field: "balance_amount", headerName: t("Pending Amount"), flex: 0.10, type: "number", density: 'compact',
            //     renderCell: ({ row }) => (<Box component={'div'}>{row?.balance_amount ? AmountFormat(row?.balance_amount).replace(`${CurrencySymbol}`, "") : "0.00"}</Box>)
            // },
            {
                field: "delivery_person_name", headerName: t("Delivery Details"), flex: 0.13, density: 'compact',
                renderCell: ({ row }) => (<div style={{ display: "flex", flexDirection: "Column" }}><Box component={'div'}>{row?.delivery_person_name?.length > 22 ?
                    <Tooltip placement='top' title={row?.delivery_person_name} arrow><div>{row?.delivery_person_name.slice(0, 20) + "..."}</div></Tooltip>
                    : row?.delivery_person_name ? row?.delivery_person_name : "-"}</Box>
                    <Box component={'div'}>{row?.delivery_contact_number ? row?.delivery_contact_number : "-"}</Box></div>), valueGetter: (params) => {
                        const name = params.row?.delivery_person_name || "";
                        const mobile = params.row?.delivery_contact_number || "";
                        return `${name} ${mobile}`;
                    }
            },
            {
                field: "delivery_address", headerName: t("Delivery Address"), flex: 0.16, density: 'compact',
                renderCell: ({ row }) => (<Box component={'div'}>{row?.delivery_address?.length > 27 ?
                    <Tooltip placement='top' title={row?.delivery_address} arrow><div>{row?.delivery_address.slice(0, 25) + "..."}</div></Tooltip>
                    : row?.delivery_address ? row?.delivery_address : "-"}</Box>)
            }
        ]
        const disablePrintExcel = this.state.disableBtn || this.state.deliveryList?.length === 0;
        return (
            <Box component={'div'} className='eMed_rts_container'>
                <Box component={"div"} className='eMed_Top_Container'>
                    <Box component={"div"} className='eMed_Cards_Container'>
                    {/* {AmountsCard(t("Total Bill Amount"), this.state.total_bill_amount)}
                    {AmountsCard(t("Total Discount"), this.state.total_concession)} */}

                    </Box>
                    <Box component={"div"} className='eMed_Action_Container'>
                        <Button className='eMed_usrconf_btn' sx={{ ml: "1vw" }} emed_tid={"eMed_action_img_TestID"} onClick={() => { this.setState({ FilterOpen: true }) }}>
                            <img src={ImagePaths.Filter.default} alt="filter" className='eMed_action_img' />
                        </Button>
                        <Tooltip title={t("Print")} placement='top' arrow>
                            <Button className='eMed_usrconf_btn'   emed_tid = {"eMed_usrconf_btn_TestID01"} disabled={disablePrintExcel} onClick={() => { this.printReports() }}>
                                <img src={disablePrintExcel ? ImagePaths.PrintIconOff.default : ImagePaths.LabPrintIcon.default} alt="print" className='eMed_action_img' />
                            </Button>
                        </Tooltip>
                    </Box>
                </Box>
                <Box component={'div'} className='eMed_rts_table'>
                    <DataGrid
                        rows={this.state.deliveryList}
                        columns={columns}
                        getRowId={(row) => row.sno}
                        page={this.state.page}
                        pageSize={this.state.pageSize}
                        localeText={{
                            toolbarColumns: "",
                            toolbarDensity: "",
                            toolbarExport: "",
                            toolbarFilters: "",
                            toolbarExportPrint: ""
                        }}
                        components={{
                            Toolbar: this.gridToolBar,
                            NoRowsOverlay: () => (
                                <Stack className='eMed_conf_nodata'>
                                    {t("NoRecordsFound")}
                                </Stack>
                            )
                        }}
                        onPageChange={(newPage) => { this.setState({ page: newPage }) }}
                        onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                        rowsPerPageOptions={[10, 20, 30]}
                        pagination
                        headerHeight={40}
                        disableSelectionOnClick
                    />
                </Box>
                <Drawer
                    anchor={'right'}
                    open={this.state.FilterOpen}
                    ModalProps={{ onBackdropClick: this.closeFilter }}
                >
                    {this.renderFilterScreen()}
                </Drawer>
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                <Loader loaderOpen={this.state.isLoader || this.state.printLoading} forPrint={this.state.printLoading ? true : false} label={this.state.printLoading ? "Building PDF..." : null} />
            </Box>
        )
    }
    closeFilter = () => {
        this.setState({ FilterOpen: false })
    }
}


export default withTranslation()(DoorDeliveryReport)